import React from "react";

// Flat vector-style illustration: person seated with phone + large map pin
const TrackingIllustration = () => (
  <div className="relative w-full flex items-center justify-center">
    <svg viewBox="0 0 420 380" className="w-full max-w-[440px]" xmlns="http://www.w3.org/2000/svg">
      {/* Phone / map grid */}
      <g>
        <rect x="150" y="40" width="210" height="300" rx="22" fill="#2B2F45" />
        <rect x="164" y="56" width="182" height="268" rx="12" fill="#3A3F5C" />
        {/* grid lines */}
        {[0, 1, 2, 3].map((i) => (
          <line key={`v${i}`} x1={164 + 45 * (i + 1)} y1="56" x2={164 + 45 * (i + 1)} y2="324" stroke="#4C5170" strokeWidth="2" />
        ))}
        {[0, 1, 2, 3, 4].map((i) => (
          <line key={`h${i}`} x1="164" y1={56 + 45 * (i + 1)} x2="346" y2={56 + 45 * (i + 1)} stroke="#4C5170" strokeWidth="2" />
        ))}
        {/* small marker bottom */}
        <rect x="190" y="250" width="34" height="34" rx="6" fill="#00C2FF" />
        <rect x="200" y="260" width="14" height="14" rx="2" fill="#fff" />
        <rect x="202" y="274" width="10" height="6" fill="#E23028" />
      </g>

      {/* Pulsing pin */}
      <g className="pin-drop">
        <circle cx="250" cy="120" r="46" fill="#00C2FF" />
        <path d="M250 78 c-26 0 -46 20 -46 46 c0 34 46 74 46 74 s46 -40 46 -74 c0 -26 -20 -46 -46 -46 z" fill="#00C2FF" opacity="0" />
        <circle cx="250" cy="120" r="18" fill="#fff" />
      </g>
      <circle cx="250" cy="120" r="46" fill="none" stroke="#00C2FF" strokeWidth="3" className="pulse-ring" style={{ transformOrigin: "250px 120px" }} />

      {/* Person */}
      <g>
        {/* legs crossed */}
        <path d="M60 320 q40 -30 100 -8 l0 20 q-60 -14 -100 4 z" fill="#3A3F5C" />
        {/* body */}
        <path d="M70 230 q30 -40 70 -20 l14 70 q-40 20 -80 6 z" fill="#8E7CE0" />
        {/* arm holding phone */}
        <path d="M120 250 q30 -6 44 14 l-10 16 q-24 -14 -40 -8 z" fill="#8E7CE0" />
        {/* small phone in hand */}
        <rect x="150" y="250" width="26" height="40" rx="5" fill="#2B2F45" transform="rotate(18 163 270)" />
        {/* head */}
        <circle cx="96" cy="196" r="26" fill="#C98B6B" />
        {/* hair */}
        <path d="M70 196 q-4 -34 30 -36 q34 2 30 36 q-8 -18 -30 -18 q-22 0 -30 18 z" fill="#2B2F45" />
      </g>

      {/* floating leaf accent */}
      <g className="floaty">
        <path d="M40 330 q-16 -6 -18 -22 q18 2 22 20 z" fill="#E23028" />
        <path d="M44 332 q14 -8 30 -4 q-14 10 -30 6 z" fill="#00C2FF" />
      </g>
    </svg>
  </div>
);

export default TrackingIllustration;
